export const selectTravelPlanList = (state) => state.travelPlan.travelPlans;
export const selectTravelPlanLoading = (state) => state.travelPlan.loading;
export const selectTravelPlanError = (state) => state.travelPlan.error;
export const selectTravelPlanUpdateLoading = (state) => state.travelPlan.updateLoading;
export const selectTravelPlanUpdateError = (state) => state.travelPlan.updateError;
export const selectTravelPlanUpdateSuccess = (state) => state.travelPlan.updateSuccess;
export const selectTravelPlanDeleteLoading = (state) => state.travelPlan.deleteLoading;
export const selectTravelPlanDeleteError = (state) => state.travelPlan.deleteError;
export const selectTravelPlanDeleteSuccess = (state) => state.travelPlan.deleteSuccess;
export const selectTravelPlanCreateLoading = (state) => state.travelPlan.createLoading;
export const selectTravelPlanCreateError = (state) => state.travelPlan.createError;
export const selectTravelPlanCreateSuccess = (state) => state.travelPlan.createSuccess;